import { CommissionsWizardFormFields } from "globalConstants";

export const mapDataMappingSection = (data?: { [key: string]: any }[]) => {
	return (
		data?.map(({ name, value }) => ({
			saveColumn: false,
			name,
			value,
			dataType: undefined,
			column: undefined,
		})) || []
	);
};

const {
	feesFieldArray: {
		feeMappingFieldArray: {
			arrayName,
			feeFromColumnFieldName,
			feeNormalizationSummaryFieldName,
		},
	},
} = CommissionsWizardFormFields;

export const mapFeeItemsSection = data => {
	return (
		data?.map(({ fee_name, fee_array }) => ({
			feeName: fee_name,
			[arrayName]: fee_array?.map(
				({ fee_col_name, fee_normalization_summary }) => ({
					[feeFromColumnFieldName]: fee_col_name,
					[feeNormalizationSummaryFieldName]:
						fee_normalization_summary,
				}),
			),
		})) || []
	);
};

export const getCommissionColumnNames = (data?: { [key: string]: any }[]) => {
	return (
		data?.map(({ name }) => ({
			value: name,
			displayName: name,
			id: name,
		})) || []
	);
};
